/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Scan_Lot_Not_In_SessionInputs */

const vi_stocktake_scan_lot_not_in_session = /** @type {(inputs: Stocktake_Scan_Lot_Not_In_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô này không có trong phiếu kiểm`)
};

/**

* @param {Stocktake_Scan_Lot_Not_In_SessionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_scan_lot_not_in_session = /** @type {((inputs?: Stocktake_Scan_Lot_Not_In_SessionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Scan_Lot_Not_In_SessionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_scan_lot_not_in_session(inputs)
});